import React, { useEffect, useRef, useState } from "react";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import ResultStageHeader from "./ResultStageHeader";
import ResultTable from "./ResultTable";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import { LevelStatusEnum } from "../../../interfaces/LevelsDTO";
import { eventBus } from "../../../services/eventHandler";

interface Props {
  race: RaceDTO;
  classid: number | null;
  level: number;
  activeLevel: number;
  vwindPropId: number;
}

const ResultStageBox = ({ race, level, classid, activeLevel,vwindPropId }: Props) => {
    const [levelStatus,setLevelStatus] = useState<LevelStatusEnum>(LevelStatusEnum.ReadyForStart);
    const [backgroundColor,setBackgroundColor] = useState<string>("");
    const tabRef = useRef<HTMLDivElement>(null); // Create a ref for the div
    useEffect(() => {
        const setHeatStatus = (status:LevelStatusEnum) => {
            setHeatColor(status);
        }
        eventBus.on(
            `lvl_status_${classid}_${level}`,
            setHeatStatus
          );
        if (classid && race.Class[classid].Level[level]){
            setHeatColor(race.Class[classid].Level[level].Status)
        }
        return () => {
            eventBus.removeListener(
                `lvl_status_${classid}_${level}`,
                setHeatStatus
              );
        }
    },[]);
    useEffect(() => {
        if (levelStatus === LevelStatusEnum.ReadyForStart && tabRef.current) {
          tabRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, [levelStatus]); // Depend on getFocusedBlade and id
    const setHeatColor = (stat:LevelStatusEnum) => {
        setLevelStatus(stat )
        if (stat === LevelStatusEnum.Running){
            setBackgroundColor("#ff9b04");
        }
        else if (stat === LevelStatusEnum.ResultConfirmed){
            setBackgroundColor("green");
        }
        else if (stat === LevelStatusEnum.ReadyForStart){
            setBackgroundColor("#73737375");
        }
    };
  return (
    <div
    ref={tabRef} 
      className={`stage-heat-${level} stage-box`}
     
      data-level={level}
      style={{ backgroundColor: level == activeLevel ? "#d79700" : undefined }}
    >
      <ResultStageHeader classid={classid} level={level} race={race} backgroundColor={backgroundColor} />
      <ResultTable
        classid={classid}
        level={level}
        Tpos={null}
        Ipos={-999}
        race={race}
        vType={ViewType.stage}
        vwindPropId={vwindPropId}
      />
    </div>
  );
};

export default ResultStageBox;
